import { m } from '@hub/messages';
import { definePageRoute } from '@hub/router/definePageRoute';
import { type DomainParents, defineDomainRoutes } from '@hub/router/domain-routes';
import { WatchPaths } from './route.paths';

export default function createWatchRoutes(parents: DomainParents) {
  const watchRoute = definePageRoute(parents, {
    path: WatchPaths.watch,
    title: m.watch_page_title,
    page: () => import('./Watch.page'),
    flag: 'page-watch',
    theme: 'dark',
  });

  return defineDomainRoutes({
    authenticated: [] as const,
    public: [watchRoute] as const,
  });
}
